import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import MenuItemContent from "./DropdownMenuItemContent";
import { getDropdownMenuItemClassName } from "./common";
import { DropdownMenuContentPropsContext } from "./common";
import { useContext } from "react";

const DropdownMenuItemLink = ({
  icon,
  shortcut,
  href,
  children,
  onSelect,
  className = "",
  selected,
  rel = "noopener",
  ...rest
}: {
  icon?: React.ReactNode;
  shortcut?: string;
  href: string;
  children: React.ReactNode;
  onSelect?: (event: Event) => void;
  className?: string;
  selected?: boolean;
  rel?: string;
} & Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "onSelect"
>) => {
  const contentProps = useContext(DropdownMenuContentPropsContext);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    (rest as any).onClick?.(e);
    onSelect?.(e as unknown as Event);
    contentProps.onSelect?.(e as unknown as Event);
  };

  return (
    <DropdownMenuPrimitive.Item asChild>
      <a
        href={href}
        rel={rel}
        target="_blank"
        onClick={handleClick}
        className={getDropdownMenuItemClassName(className, selected)}
        {...rest}
      >
        <MenuItemContent icon={icon} shortcut={shortcut}>
          {children}
        </MenuItemContent>
      </a>
    </DropdownMenuPrimitive.Item>
  );
};

export default DropdownMenuItemLink;
DropdownMenuItemLink.displayName = "DropdownMenuItemLink";
